var render = function render(){var _vm=this,_c=_vm._self._c;return _c('TooltipIconButton',_vm._g({attrs:{"icon":"mdi-file-replace","tooltipText":_vm.text,"color":_vm.color,"disabled":_vm.disabled}},_vm.$listeners))
}
var staticRenderFns = []

export { render, staticRenderFns }